import { render } from "./CategoriesModal.vue?vue&type=template&id=29244738&scoped=true"
import script from "./CategoriesModal.vue?vue&type=script&lang=js"
export * from "./CategoriesModal.vue?vue&type=script&lang=js"

import "./CategoriesModal.vue?vue&type=style&index=0&id=29244738&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29244738"]])

export default __exports__